module.exports = __webpack_public_path__ + "static/media/Futura LT Light-01.7766e499.svg";